import { Suspense } from "react";

import { cssReset } from "@/libraries/wpl/foundations/src";
import GlobalFooter from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";

import { ConfluenceSoftwarePageProps } from "../../../pages/confluence/confluence-software-page";

import AdditionalResourcesSection from "./sections/additional-resources";
import CtaSection from "./sections/cta";
import FeaturesSection from "./sections/features";
import HeroSection from "./sections/hero";
import IntegrationsSection from "./sections/integrations";
import MobileSection from "./sections/mobile";
import PricingSection from "./sections/pricing";
import ResourcesSection from "./sections/resources";
import SocialProof from "./sections/social-proof";
import ConfluenceSoftwareNav from "./sections/software-confluence-navbar";
import TemplatesSection from "./sections/templates";
import TestimonialsSection from "./sections/testimonials";
import WhyConfluenceSection from "./sections/why-confluence";

export const ConfluenceSoftwarePageTemplate = (
    props: ConfluenceSoftwarePageProps
) => {
    return (
        <div css={cssReset}>
            <div>
                <GlobalNavigation showTryNow={false} color={"#f4f5f7"} />
            </div>
            <ConfluenceSoftwareNav />
            <HeroSection />
            <FeaturesSection />
            <WhyConfluenceSection />
            <TemplatesSection />
            <IntegrationsSection />
            <TestimonialsSection />
            <SocialProof />
            <ResourcesSection />
            <AdditionalResourcesSection />
            <Suspense>
                <PricingSection
                    serverSidePricing={
                        props.pricing?.localizedPriceBlock.confluence
                    }
                />
            </Suspense>
            <MobileSection />
            <CtaSection />
            <GlobalFooter />
        </div>
    );
};
